<template lang="pug">
  div
    header-without-menu
    div.content.access.join(:class="{loaded}")
      div.center-form.join-form
        div.text-center
          div: img(src="../../../assets/main_logo.svg")
          div.mt-4.mb-3(v-html="$t(agreement ? 'join_description' : 'agreement.desc')")
        b-row(v-if="agreement")
          div.ml-3 {{$t('required')}}
          b-card.w-100(no-body)
            b-list-group.list-input(flush)
              b-list-group-item
                b-input-group
                  b-input-group-prepend(is-text)
                    icon(name="id-badge")
                  b-input-group-text(slot="append")
                    icon(name="check", :class="{'text-success': validates.mgrid && validates.exist}")
                  b-form-input(
                    type="text",
                    v-model="form.mgrid",
                    aria-describedby="inputIDFeedback",
                    :placeholder="$t('ID')",
                    @input="isValidId")
                  div.validate-text(v-if="!validates.exist")
                    | {{$t('id_exist')}}
              b-list-group-item
                b-input-group
                  b-input-group-prepend(is-text)
                    icon(name="lock")
                  b-input-group-text(slot="append" @click="toggleShowPw")
                    icon(:name="iconName" style="color: #8c8c8c;")
                  b-input-group-text(slot="append")
                    icon(name="check", :class="{'text-success': validates.pw}")
                  b-form-input(
                    :type="showPw ? 'text' : 'password'"
                    autocomplete="new-password",
                    v-model="form.pw",
                    :placeholder="$t('PW')",
                    @input="isValidPw")
              b-list-group-item
                b-input-group.fa-style
                  b-input-group-prepend(is-text)
                    icon(name="envelope")
                  b-input-group-text(slot="append")
                    icon(name="check", :class="{'text-success': validates.mail}")
                  i.fas.fa-question-circle.fa-lg(@click="HelpJoin")
                  b-form-input(
                    type="text",
                    v-model="form.mail",
                    :placeholder="$t('Email')",
                    @input="isValidEmail")
              b-list-group-item
                b-input-group
                  b-input-group-prepend(is-text)
                    icon(name="user")
                  b-input-group-text(slot="append")
                    icon(name="check", :class="{'text-success': validates.name}")
                  b-form-input(
                    type="text",
                    v-model="form.name",
                    :placeholder="$t('name')",
                    @input="isValidName")


        b-row.mt-3(v-if="agreement")
          div.ml-3 {{$t('selections')}}
          b-card.w-100(no-body)
            b-list-group.list-input(flush)
              b-list-group-item
                b-input-group.fa-style
                  b-input-group-prepend(is-text)
                    icon(name="phone")
                  i.fas.fa-question-circle.fa-lg(@click="HelpJoin")
                  b-input-group-text(slot="append")
                    icon(name="check", :class="{'text-success': validates.phone}")
                  b-form-input(
                    type="text",
                    v-model="form.phone",
                    :placeholder="$t('phone')",
                    @input="isValidPhone")
              //b-list-group-item
              //  b-input-group
              //    b-input-group-prepend(is-text)
              //      icon(name="paper-plane-o")
              //    b-input-group-text(slot="append")
              //      icon(name="check", :class="{'text-success': validates.subscribe}")
              //    b-form-select(v-model="subscribe.selected", @input="isValidSubscribe")
              //      template(slot="first")
              //        option(:value="null", disabled) {{$t('subscription_path')}}
              //      option(v-for="opt in subscribe.options", :key="opt.text", :value="opt.value") {{$t(opt.text)}}
              //b-list-group-item
              //  b-input-group
              //    b-input-group-text(slot="prepend") {{$t('is_pcany_customer')}}
              //    div.form-control
              //    b-input-group-text(slot="append")
              //      b-form-radio-group(v-model="form.pcany_user")
              //        b-form-radio(value="YES") Yes
              //        b-form-radio(value="NO") No
              b-list-group-item
                b-input-group
                  b-input-group-text(slot="prepend") {{$t('use_for')}}
                  div.form-control
                  b-input-group-text(slot="append")
                    b-form-radio-group.radio-style(v-model="useFor")
                      // 폰트 색깔 바꿔야함
                      b-form-radio(value="PERSONAL") {{$t('personal')}}
                      b-form-radio(value="ENTERPRISE", checked) {{$t('enterprise')}}
              template(v-if="useFor === 'ENTERPRISE'")
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="building")
                    b-input-group-text(slot="append")
                      icon(name="check", :class="{'text-success': validates.company_name}")
                    b-form-input(
                      type="text",
                      v-model="form.company_name",
                      :placeholder="$t('company') + ' ' + $t('name')",
                      @input="isValidCompanyName",
                      )
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="globe")
                    b-form-input(
                      type="text",
                      v-model="form.company_website",
                      :placeholder="$t('company') + ' ' + $t('homepage')")
        b-row(v-else)
          b-card.w-100(no-body)
            b-list-group(flush)
              b-list-group-item
                div.agree-title {{$t('agreement.agree_all')}}
                  toggle-box.float-right(
                    :checked="checked.all",
                    field="all",
                    @input="check")
              b-list-group-item
                div.agree-title.pb-2 {{$t('agreement.agree_use')}}
                  toggle-box.float-right(
                    :checked="checked.use",
                    field="use",
                    @input="check")
                div.agree-context {{$t('agreement.agree_use_context')}}
              b-list-group-item
                div.agree-title.pb-2 {{$t('agreement.agree_privacy')}}
                  toggle-box.float-right(
                    :checked="checked.privacy",
                    field="privacy",
                    @input="check")
                div.agree-context {{$t('agreement.agree_privacy_context')}}
        b-row.mt-3(v-if="agreement")
          b-col(cols="6")
            b-btn.w-100(@click="regist") {{$t('signup')}}
          b-col(cols="6")
            b-btn.w-100(:to="{name: 'login'}") {{$t('cancel')}}
        b-row.mt-3(v-else)
          b-col(cols="6")
            b-btn.w-100(@click="next") {{$t('continue')}}
          b-col(cols="6")
            b-btn.w-100(:to="{name: 'login'}") {{$t('cancel')}}
</template>

<script>
import _ from 'lodash'
import {ManagersAPI, CheckAPI} from '@/api'
import { HeaderWithoutMenu } from '../../mixins/header'
import ToggleBox from '../../mixins/togglebox'
export default {
  name: 'join-component',
  components: { HeaderWithoutMenu, ToggleBox },
  methods: {
    isValidId: _.debounce(function () {
      let id = this.form.mgrid
      if (/^[a-zA-Z0-9@._-]{4,38}$/g.test(id)) {
        this.validates.mgrid = true
        let params = {
          timestamp: _.now(),
          type: 'mail',
          value: id
        }
        CheckAPI.get('', {params})
          .then(({data}) => {
            this.validates.exist = data.objects.available
          })
      } else {
        this.validates.mgrid = false
      }
    }),
    isValidPw () {
      let pw = this.form.pw
      if (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw)) {
        this.validates.pw = true
      } else {
        this.validates.pw = false
      }
    },
    // isValidPwConfirm () {
    //   let pw = this.form.pw
    //   let pwConfirm = this.form.pwConfirm
    //   if (pwConfirm && pw === pwConfirm) {
    //     this.validates.pwConfirm = true
    //   } else {
    //     this.validates.pwConfirm = false
    //   }
    // },
    isValidName () {
      this.validates.name = Boolean(this.form.name)
    },
    isValidPhone () {
      this.validates.phone = Boolean(this.form.phone) // 나중에 정규식으로
    },
    isValidEmail () {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validates.mail = reg.test(this.form.mail)
    },
    // isValidSubscribe () {
    //   this.validates.subscribe = Boolean(this.subscribe.selected)
    // },
    isValidCompanyName () {
      this.validates.company_name = Boolean(this.form.company_name)
    },
    // isValidWebsite () {
    //   this.validates.company_website = Boolean(this.form.company_website)
    // },
    regist () {
      const vd = this.validates
      if (!vd.mgrid) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_id'}
        })
        return
      }
      if (!vd.exist) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'id_exist'}
        })
        return
      }
      if (!vd.pw) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'password_requirement'}
        })
        return
      }
      // if (!vd.pwConfirm) {
      //   this.AppState.$emit('show-message-dialog', {
      //     title: 'LinkMeMine',
      //     context: {path: 'password_confirm'}
      //   })
      //   return
      // }
      if (!vd.name) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'name_requirement'}
        })
        return
      }
      if (!vd.mail) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'email-invalid'}
        })
        return
      }
      // if (!vd.phone) {
      //   this.AppState.$emit('show-message-dialog', {
      //     title: 'LinkMeMine',
      //     context: {path: 'phone_requirement'}
      //   })
      //   return
      // }
      // if (!vd.subscribe) {
      //   this.AppState.$emit('show-message-dialog', {
      //     title: 'LinkMeMine',
      //     context: {path: 'subspath_requirement'}
      //   })
      //   return
      // }
      // if (this.useFor === 'ENTERPRISE') {
      //   if (!vd.company_name) {
      //     this.AppState.$emit('show-message-dialog', {
      //       title: 'LinkMeMine',
      //       context: {path: 'company_name_requirement'}
      //     })
      //     return
      //   }
      // } else {
      //   this.form.company_name = ''
      //   this.form.company_website = ''
      // }
      ManagersAPI.post('', this.form)
        .then(resp => {
          this.$router.push({ name: 'join-done' })
        })
    },
    next () {
      if (this.checked.all === true) this.agreement = true
    },
    check (key, value) {
      if (key === 'all') {
        if (value) {
          this.checked.all = true
          this.checked.use = true
          this.checked.privacy = true
        } else {
          this.checked.all = false
          this.checked.use = false
          this.checked.privacy = false
        }
      } else if (key === 'use') {
        if (value) {
          this.checked.use = true
          if (this.checked.privacy === true) this.checked.all = true
        } else {
          this.checked.use = false
          this.checked.all = false
        }
      } else if (key === 'privacy') {
        if (value) {
          this.checked.privacy = true
          if (this.checked.use === true) this.checked.all = true
        } else {
          this.checked.privacy = false
          this.checked.all = false
        }
      }
    },
    HelpJoin () {
      this.AppState.$emit('show-helpOTP-dialog', { context: {path: 'help_email'} })
    },
    toggleShowPw () {
      this.showPw = !this.showPw
      this.iconName = this.showPw ? 'eye' : 'eye-slash'
    }
  },
  mounted () {
    this.loaded = true
  },
  data () {
    return {
      loaded: false,
      agreement: false,
      showPw: false,
      iconName: 'eye-slash',
      // subscribe: {
      //   selected: null,
      //   options: [
      //     { value: '인터넷 검색', text: 'getin_with.internet_search' },
      //     { value: '지인 추천', text: 'getin_with.recommendation' },
      //     { value: '광고/신문/매체', text: 'getin_with.advertising' },
      //     { value: 'SNS/블로그', text: 'getin_with.sns' },
      //     { value: '피씨애니 유료 고객', text: 'getin_with.pcany' },
      //     { value: '기타', text: 'getin_with.etc' }
      //   ]
      // },
      checked: {
        all: false,
        use: false,
        privacy: false
      },
      form: {
        company_name: null,
        company_website: null,
        lang_code: 'ko',
        mail: null,
        mgrid: null,
        name: null,
        pcany_user: 'NO',
        phone: null,
        pw: null,
        subscription: null,
        time_zone_id: 32
      },
      validates: {
        mgrid: false,
        exist: true,
        name: false,
        pw: false,
        pwConfirm: false,
        mail: false,
        phone: false,
        subscribe: false
      },
      useFor: 'ENTERPRISE'
    }
  }
}
</script>

<style lang="scss" scoped src="../access.scss"></style>
<style lang="scss" scoped>
.loaded .join-form {
  margin-top: 20px;
}

.agree-title {
  font-size: 16px;
  font-weight: 400;
}

.agree-context {
  white-space: pre-line;
  padding: 0 10px;
  height: 120px;
  overflow-y: auto;
  background-color: #efefef;
}

.list-input {
  .list-group-item {
    padding: 4px;
  }
  .form-control {
    border: 0;
    &:focus { box-shadow: none; }
  }
  .input-group-text {
    color: #ccc;
    border: 0;
    background-color: transparent;
    min-width: 46px;
    svg { margin: 0 auto; }
  }
}
.validate-text {
  font-size: 10px;
  line-height: 36px;
  color: #bdbdbd;
}

.radio-style {
  color: #495057;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.fa-style {
  align-items: center;
}

.fas{
  cursor: pointer;
}
</style>
